import React from 'react';
import Button from '@atlaskit/button/standard-button';
import EmptyState from '@atlaskit/empty-state';
import { DocumentTitle } from '@atlassian/jira-global-document-title/src/DocumentTitle.tsx';
import EmptyFolderImage from '@atlassian/jira-illustrations/src/ui/adg4/brand/spots/objects/components/folder/index.tsx';
import { getAkEmptyStateRenderImageFn } from '@atlassian/jira-illustrations/src/ui/helpers/ak-empty-state/index.tsx';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { IntlShapeV2 as IntlShape } from '@atlassian/jira-intl/src/v2/types.tsx';
import {
	ContextualAnalyticsData,
	SCREEN,
	FireScreenAnalytics,
} from '@atlassian/jira-product-analytics-bridge';
import SubmitApdex from '@atlassian/jira-providers-spa-apdex-analytics/src/submit-apdex-mark/index.tsx';
import { PageLayout } from '@atlassian/jira-spa-apps-page-layout/src/page/index.tsx';
import { MarkProductStart } from '@atlassian/jira-spa-performance-breakdown/src/utils/mark-product-start/index.tsx';
import { projectArchivedPageLoad } from '../utils/performance-analytics/index.tsx';
import messages from './messages.tsx';

type Props = {
	intl: IntlShape;
};

const APP_NAME = 'project_archived_direct_link';

export const ArchivedProjectDirectLink = ({ intl: { formatMessage } }: Props) => {
	const primaryAction = (
		<Button appearance="primary" href="/projects">
			{formatMessage(messages.viewProjects)}
		</Button>
	);
	return (
		<>
			<MarkProductStart />
			<ContextualAnalyticsData sourceName="archivedProjectDirectLink" sourceType={SCREEN}>
				<DocumentTitle title={formatMessage(messages.documentTitle)} />
				<PageLayout>
					<EmptyState
						renderImage={getAkEmptyStateRenderImageFn(EmptyFolderImage)}
						header={formatMessage(messages.header)}
						description={formatMessage(messages.description)}
						primaryAction={primaryAction}
					/>
				</PageLayout>
				<FireScreenAnalytics />
				{/* @ts-expect-error - TS2769 - No overload matches this call. */}
				<SubmitApdex appName={APP_NAME} metric={projectArchivedPageLoad} />
			</ContextualAnalyticsData>
		</>
	);
};

export default injectIntl(ArchivedProjectDirectLink);
